<template>
  <div>
    <template v-for="(order, index) in orders">
      <span
        class="badge badge-secondary"
        style="margin-right: 5px;">
        <!-- item -->
        {{ order.item }}
        <!-- modifiers -->
        <template v-if="order.modifiers">
          <template v-if="order.modifiers.length > 0">
            (<template v-for="(modifier, idx) in order.modifiers">{{ modifier.option }}<span v-if="idx < order.modifiers.length - 1">, </span></template>)
          </template>
        </template>
        <!-- quantity -->
        x{{ order.quantity }}
        <!-- price -->
        <span
          v-if="isShowPrice"
          class="badge badge-light">
          {{ currencyFormatter(getPrice(order), { code: currency }) }}
        </span>
        <!-- new line -->
      </span>
      <br >
      <!-- <br v-if="(index+1) % 2 == 0 && (index+1) !== orders.length" /> -->
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    orders: {
      required: true,
      type: Array,
    },
    isShowPrice: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currency: 'getCurrency',
      getBillTotalPrice: 'getBillTotalPrice',
    }),
  },
  methods: {
    adjustModifiers (orders) {
      let cloneOrders = _.cloneDeep(orders)
      cloneOrders.map(order => {
        let tempModifiers = order.modifiers
        order.modifiers = [{ options: [] }]
        tempModifiers.map(modi => {
          order.modifiers[0].options.push(modi)
        })
      })
      return cloneOrders
    },
    getPrice (order) {
      var orders = this.adjustModifiers([order])
      var getTotal = this.getBillTotalPrice(orders, this.mixin)
      return getTotal.total
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/custom/ItemList.vue